import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { AdminModule } from '@/store/modules/admin';
import Breadcrumb from '@/components/Breadcrumb/index.vue';
import ErrorLog from '@/components/ErrorLog/index.vue';
import Hamburger from '@/components/Hamburger/index.vue';
import HeaderSearch from '@/components/HeaderSearch/index.vue';
import LangSelect from '@/components/LangSelect/index.vue';
import Screenfull from '@/components/Screenfull/index.vue';
import SizeSelect from '@/components/SizeSelect/index.vue';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.loggedInUser = AdminModule.name || null;
    this.baseUrl = process.env.VUE_APP_BASE_API;
    this.adminVersion = process.env.VUE_APP_VERSION;
    this.isFullscreen = false;
  }
  mounted() {
    // Listen for fullscreen changes
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
    // Listen for escape key
    document.addEventListener('keydown', this.handleKeydown);
  }
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
    document.removeEventListener('keydown', this.handleKeydown);
  }
  get role() {
    if (AdminModule.roles.length) {
      return AdminModule.roles.toString();
    } else {
      return null;
    }
  }
  get sidebar() {
    return AppModule.sidebar;
  }
  get device() {
    return AppModule.device.toString();
  }
  get avatar() {
    if (AdminModule.avatar.length === 0) {
      return 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif';
    }
    return AdminModule.avatar;
  }
  toggleSideBar() {
    AppModule.ToggleSideBar(false);
  }
  toggleFullscreen() {
    if (this.isFullscreen) {
      this.exitFullscreen();
    } else {
      this.enterFullscreen();
    }
  }
  enterFullscreen() {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  }
  exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
  handleFullscreenChange() {
    this.isFullscreen = !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
  }
  handleKeydown(event) {
    if (event.key === 'Escape' && this.isFullscreen) {
      this.exitFullscreen();
    }
  }
  async logout() {
    // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    switch (AdminModule.userType) {
      case 'Admin':
        await AdminModule.LogOut();
        this.$router.push('/login');
        break;
      case 'Agent':
        await AdminModule.AgentLogOut();
        this.$router.push('/agent-login');
        break;
      default:
        break;
    }
  }
};
default_1 = __decorate([Component({
  name: 'Navbar',
  components: {
    Breadcrumb,
    ErrorLog,
    Hamburger,
    HeaderSearch,
    LangSelect,
    Screenfull,
    SizeSelect
  }
})], default_1);
export default default_1;